import { Component, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { AbstractErrorControlComponent } from '../../forms/abstract-error-control/abstract-error-control.component';
import { AppFormsService } from '../../forms/app-forms.service';
import { UserService } from '../../shared/services/user.service';


@Component({
  selector: 'journey-esigning',
  templateUrl: './journey-esigning.component.html'
})
export class JourneyEsigningComponent  extends AbstractErrorControlComponent implements OnInit, OnDestroy {

    @Input() userType !: string;
    @Input() queryString !: string;

    @ViewChild('journeyEsigningForm', { static: true }) ngForm !: NgForm;

    protected submitted = false;
    private subscription !: Subscription;
    private data !: string | null;
    showSpinner = false;
    taxId !: string;

    constructor(override formsService: AppFormsService,
                          private userService: UserService,
                          private route: ActivatedRoute,
                          private router: Router){
      super(formsService);
    }

    ngOnInit(): void {
      const params = this.route.snapshot.queryParamMap;
      this.data = params.get('data');
    }

    override ngOnDestroy() : void {
      super.ngOnDestroy();
      this.subscription?.unsubscribe();
    }

    onSubmit() {
        this.showErrors();
        if(this.ngForm.invalid) {
          return;
        }
        let formdata = this.ngForm.form.value;
        const encodedString = btoa(`${formdata.signerEmail?.trim()?.toLowerCase()}:${formdata.taxId?.trim()}`);

        this.submitted = true;

         this.userService.getEsigningLink(this.userType, this.data, this.queryString, encodedString).subscribe({
          next: (url) => {
              this.showSpinner = true;
              setTimeout(() => {
                window.location.href = url;
              }, 500);
              this.submitted = false; 
          },
          //next: (isValid) => {
          // if (isValid) {
          //   this.redirectToEsigning();
          // } else {
          //   this.router.navigate(['../invalidRegLink'], { relativeTo: this.route });
          // }
        //},
        error: () => {
          this.submitted = false;
          this.router.navigate(['../invalidRegLink'], { relativeTo: this.route });
        }
      });
    }

    // private redirectToEsigning(encodedString: string) {
    //     this.userService.getEsigningLink(this.userType, this.data, this.queryString, encodedString).subscribe({
    //       next: (url) => {
    //           this.showSpinner = true;
    //           setTimeout(() => {
    //             window.location.href = url;
    //           }, 500);
    //           this.submitted = false; 
    //       }
    //     });
    // }
}
